export default {"src":"/_next/static/media/vector-three.36789a5e.svg","height":173,"width":70};